// Utility to manage recent activities (meeting room searches)

const getActivitiesKey = () => {
  try {
    const user = localStorage.getItem('user');
    if (user) {
      const userObj = JSON.parse(user);
      return `meetingActivities_${userObj._id || userObj.id}`;
    }
  } catch (error) {
    console.error('Error getting user ID:', error);
  }
  return 'meetingActivities'; // Fallback for non-logged-in users
};

// Save a new activity
export const saveActivity = (activityData) => {
  try {
    const key = getActivitiesKey();
    const activities = getActivities();
    
    // Create activity object
    const newActivity = {
      id: Date.now(),
      type: 'meeting_search',
      location: activityData.location,
      date: activityData.date,
      startTime: activityData.startTime,
      endTime: activityData.endTime,
      participants: activityData.participants || 1,
      timestamp: new Date().toISOString(),
      searchParams: activityData.searchParams || null
    };

    // Remove duplicates - check if same search exists (same location, date, startTime, endTime)
    const filteredActivities = activities.filter(activity => {
      return !(
        activity.location === newActivity.location &&
        activity.date === newActivity.date &&
        activity.startTime === newActivity.startTime &&
        activity.endTime === newActivity.endTime
      );
    });

    // Add new activity at the beginning (most recent first)
    const updatedActivities = [newActivity, ...filteredActivities].slice(0, 10); // Keep only latest 10

    // Save to localStorage
    localStorage.setItem(key, JSON.stringify(updatedActivities));
    
    // Dispatch custom event for real-time updates
    window.dispatchEvent(new CustomEvent('meetingActivityUpdated', {
      detail: updatedActivities
    }));

    return updatedActivities;
  } catch (error) {
    console.error('Error saving activity:', error);
    return [];
  }
};

// Get all activities
export const getActivities = () => {
  try {
    const key = getActivitiesKey();
    const stored = localStorage.getItem(key);
    if (stored) {
      const activities = JSON.parse(stored);
      // Sort by timestamp (newest first) and remove duplicates
      const uniqueActivities = [];
      const seen = new Set();
      
      activities.forEach(activity => {
        const key = `${activity.location}_${activity.date}_${activity.startTime}_${activity.endTime}`;
        if (!seen.has(key)) {
          seen.add(key);
          uniqueActivities.push(activity);
        }
      });
      
      return uniqueActivities.sort((a, b) => 
        new Date(b.timestamp) - new Date(a.timestamp)
      );
    }
  } catch (error) {
    console.error('Error getting activities:', error);
  }
  return [];
};

// Clear all activities
export const clearActivities = () => {
  try {
    const key = getActivitiesKey();
    localStorage.removeItem(key);
    window.dispatchEvent(new CustomEvent('meetingActivityUpdated', {
      detail: []
    }));
  } catch (error) {
    console.error('Error clearing activities:', error);
  }
};

// Remove a specific activity
export const removeActivity = (activityId) => {
  try {
    const key = getActivitiesKey();
    const activities = getActivities();
    const filtered = activities.filter(activity => activity.id !== activityId);
    localStorage.setItem(key, JSON.stringify(filtered));
    
    window.dispatchEvent(new CustomEvent('meetingActivityUpdated', {
      detail: filtered
    }));
    
    return filtered;
  } catch (error) {
    console.error('Error removing activity:', error);
    return [];
  }
};














